module.exports = __webpack_public_path__ + "img/mainPicture.f7719db5.png";